import { to } from "await-to-js";
import http from "../http";
import urls from "../urls";

export default new (class {
  getAllWidgets() {
    //PAGINATION CONTROL
    var url = new URL(window.location.href);
    var page = url.searchParams.get("page");
    if (page === null) {
      return to(http.get(`${urls.widgets.get}`));
    } else {
      return to(http.get(`${urls.widgets.get + "?page=" + page}`));
    }
  }
  getAllAllWidgets() {
    return to(http.get(`${urls.widgets.get + "?pageSize=100"}`));
  }
  getWidgetById(id) {
    return to(http.get(`${urls.widgets.get}/${id}`));
  }
  deleteById(id) {
    return to(http.delete(`${urls.widgets.get}/${id}`));
  }
  getWidgetsByPage(page) {
    if (page === null) {
      return to(http.get(`${urls.widgets.get}`));
    } else {
      return to(http.get(`${urls.widgets.get + "?page=" + page}`));
    }
  }
  getPageByName(slug, lang) {
    return to(http.get(`${urls.pages.getPageByName}/${slug}/${lang}`));
  }
})();
